document.addEventListener('DOMContentLoaded', () => {
  const style = document.createElement('style');
  style.textContent = `
    .template-product .free-shipping-bar {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    .template-product .free-shipping-bar__text {
      margin-bottom: 5px !important;
      font-size: 12px !important;
      line-height: 1.25 !important;
      color: #666 !important;
    }

    .template-product .free-shipping-bar__track {
      height: 4px !important;
      background-color: #ececec !important;
    }

    .template-product .free-shipping-bar__track::before {
      background: #f1ab3c !important;
    }

    /* Keep every free-shipping progress bar visually consistent and remove Venue's rainbow gradient. */
    .free-shipping-bar__track {
      background-color: #ececec !important;
    }

    .free-shipping-bar__track::before {
      background: #f1ab3c !important;
    }

    /* Cart drawer: keep recommendations useful but visually secondary. */
    .cart--draw .cart-recommendations {
      padding-top: 14px !important;
      padding-bottom: 12px !important;
    }

    .cart--draw .cart-recommendations__title {
      padding-bottom: 8px !important;
    }

    .cart--draw .cart-recommendations__title-text--reduced {
      font-size: 1rem !important;
      line-height: 1.3 !important;
    }

    .cart--draw .cart-recommendations .product-card--mini {
      width: 310px !important;
      min-width: 310px !important;
    }

    /* Preserve Venue's native scrollable cart area, especially on mobile. */
    .cart--draw .cart__contents {
      min-height: 0 !important;
      overflow-y: auto !important;
      -webkit-overflow-scrolling: touch;
    }

    .cart--draw .cart__controls {
      margin-top: 0 !important;
    }

    /* Cart drawer actions: match the product-page button hierarchy and square geometry. */
    .cart--draw .cart__view,
    .cart--draw .cart__checkout {
      border-radius: 0 !important;
      box-shadow: none !important;
    }

    .cart--draw .cart__view {
      color: #212121 !important;
      background: #ffffff !important;
      border: 1px solid #212121 !important;
    }

    .cart--draw .cart__checkout {
      color: #ffffff !important;
      background: #212121 !important;
      border: 1px solid #212121 !important;
    }

    .cart--draw .cart__checkout .icon,
    .cart--draw .cart__checkout svg {
      color: #ffffff !important;
    }

    @media screen and (max-width: 480px) {
      .cart--draw .cart-recommendations .product-card--mini {
        width: 270px !important;
        min-width: 270px !important;
      }
    }

    /* Mobile collections: briefly crossfade to the second product photo as the card enters view. */
    @media screen and (max-width: 767px) and (prefers-reduced-motion: no-preference) {
      .template-collection product-card.product-card .product-card__img-hover.hover-enabled {
        visibility: visible !important;
        opacity: 0 !important;
        transform: scale(1.015);
        transition: opacity 850ms ease, transform 1400ms ease !important;
        pointer-events: none;
        z-index: 1;
      }

      .template-collection product-card.product-card.th-mobile-secondary-preview .product-card__img-hover.hover-enabled {
        visibility: visible !important;
        opacity: 1 !important;
        transform: scale(1);
      }
    }
  `;
  document.head.appendChild(style);

  /* Venue disables product-card hover effects on touch devices. On mobile, preview photo 2 once on entry. */
  const mobileCollectionMedia = window.matchMedia('(max-width: 767px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (
    document.body.classList.contains('template-collection') &&
    mobileCollectionMedia.matches &&
    !reduceMotion.matches &&
    'IntersectionObserver' in window
  ) {
    let cardIndex = 0;

    const secondaryPreviewObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;
          if (!entry.isIntersecting || card.dataset.thSecondaryPreviewDone === 'true') return;

          card.dataset.thSecondaryPreviewDone = 'true';
          secondaryPreviewObserver.unobserve(card);

          const delay = Number(card.dataset.thSecondaryPreviewDelay || 0);
          window.setTimeout(() => {
            card.classList.add('th-mobile-secondary-preview');
            window.setTimeout(() => {
              card.classList.remove('th-mobile-secondary-preview');
            }, 2600);
          }, 450 + delay);
        });
      },
      {
        threshold: 0.35,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    const prepareSecondaryPreviewCards = (root) => {
      const cards = [];

      if (root instanceof Element && root.matches('product-card.product-card')) {
        cards.push(root);
      }

      if (root.querySelectorAll) {
        cards.push(...root.querySelectorAll('product-card.product-card'));
      }

      cards.forEach((card) => {
        if (card.dataset.thSecondaryPreviewPrepared === 'true') return;
        if (!card.querySelector('.product-card__img-hover.hover-enabled')) return;

        card.dataset.thSecondaryPreviewPrepared = 'true';
        card.dataset.thSecondaryPreviewDelay = String((cardIndex % 2) * 90);
        cardIndex += 1;
        secondaryPreviewObserver.observe(card);
      });
    };

    prepareSecondaryPreviewCards(document);

    const secondaryPreviewMutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) prepareSecondaryPreviewCards(node);
        });
      });
    });

    secondaryPreviewMutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});